var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "menu-container" }, [
    _c(
      "div",
      {
        staticClass: "menu-item",
        on: {
          change: function($event) {
            return _vm.$emit("updateImage", $event)
          }
        }
      },
      [
        _c("input", {
          staticClass: "photo-input",
          attrs: { type: "file", accept: "image/*", title: "" }
        }),
        _vm._v("\n    " + _vm._s(_vm.$t("ChangePhoto")) + "\n  ")
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "menu-item",
        on: {
          click: function($event) {
            return _vm.$emit("removeImage")
          }
        }
      },
      [_vm._v("\n    " + _vm._s(_vm.$t("DeletePhoto")) + "\n  ")]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-11fe2c4c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-11fe2c4c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/Forms/_SpecialTabs/Photos/PhotoMenu.vue
// module id = null
// module chunks = 